import { createFileRoute } from '@tanstack/react-router';
import { ProjectsHead } from '@/features/projects/ui/ProjectsHead';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { SyncHistoryPage } from '@/features/sync/SyncHistoryPage';

export const Route = createFileRoute('/_authenticated/projects/sync/')({
  component: () => (
    <div className="flex flex-col gap-4">
      <ProjectsHead subtitle="Lịch sử gửi duyệt" />
      <SyncHistoryPage config={SHEET_TABS.projects} />
    </div>
  ),
});
